import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

const Svg = (props) => (
    <StaticQuery
        query={graphql`
            query {
                image: allFile(filter:{extension:{regex:"/(svg)/"}}) {
                    edges {
                        node {
                            relativePath
                            name
                            extension
                            publicURL
                        }
                    }
                }
            }
        `}

        render={(data) => {

            const image = data.image.edges.find(n => {
                return n.node.relativePath.includes(props.filename + ".svg");
            });

            const publicURL = image.node.publicURL;

            return (
                <img className={props.className}
                    alt={props.alt}
                     src={publicURL}
                />
            );
        }}
    />
);

export default Svg